export interface ResolveConfirmationEarnPointsParams {
  /** Points from the backend `getReservation` response (`earnAmount.totalPoints`). */
  backendPoints: number | undefined;
  /** Frontend estimate reused from the checkout Avion summary. */
  estimatedPoints: number;
  /** Whether the checkout estimate is renderable (eligible BIN + non-zero fiat). */
  isEstimateEligible: boolean;
}

/**
 * Resolve the point count for the hotel confirmation earn subtitle (RBC-2240).
 *
 * Precedence:
 * 1. Backend `earnAmount.totalPoints` when defined and > 0.
 * 2. Otherwise the checkout frontend estimate, when eligible and > 0.
 * 3. Otherwise `undefined` — caller renders the no-points copy.
 */
export const resolveConfirmationEarnPoints = ({
  backendPoints,
  estimatedPoints,
  isEstimateEligible,
}: ResolveConfirmationEarnPointsParams): number | undefined => {
  if (backendPoints != null && backendPoints > 0) return backendPoints;
  if (isEstimateEligible && estimatedPoints > 0) return estimatedPoints;
  return undefined;
};
